import capitalizeStringUtil from 'utils/string/capitalize'

const UNLOCK_ON = 'Unlock on '

export default function getUnlockOnLabelProductUtil (tierName) {
  return `${UNLOCK_ON}${capitalizeStringUtil(tierName)}`
}
